import { NoRecordingError } from './recordingError';
import { encodeWav } from './recordingUtils';

export const getIsVrResultProcessingTimeout = state => state.isVrResultProcessingTimeout;

export const getIsRecordingInProgress = state => state.isRecordingInProgress;

export const getRecordedResult = state => state.recordedResult;

export const getEncodedWavResult = async state => {
    const blobResult = getRecordedResult(state);

    if (!blobResult) {
        throw new NoRecordingError();
    }

    const convertedBlobResult = await encodeWav(blobResult);
    return convertedBlobResult;
};

export const getRecordingStream = state => state.recordingStream;

export const didPermissionsFail = state => state.didPermissionsFail;

export const isMicCheckPassed = state => state.isMicCheckPassed;

export const getIsRecordingSaved = state => state.isRecordingSaved;

export const getIsRecordingSavingInProgress = state => state.isRecordingSavingInProgress;

export const getIsOfflineAudioSyncInProgress = state => state.isOfflineAudioSyncInProgress;

export const getMicTestAttemptCount = state => state.micTestAttemptCount;

export const getRecordingError = state => state.recordingError;
